import React from "react";

import { noop } from "../../../utils";

import { PaginationWrapper, Count } from "./style";

function Pagination({
  m = "32px 0 0 0",
  variant = "label3",
  pageNo,
  setPageNo = noop,
  isPerviousPage,
  isNextPage,
  totalPages,
  pages,
}) {
  return (
    <PaginationWrapper m={m}>
      <Count
        variant={variant}
        isNextPrevious
        onClick={() => isPerviousPage && setPageNo((prevState) => prevState - 1)}
        disabled={!isPerviousPage}
      >
        Previous
      </Count>
      {pages.map((value) => (
        <Count
          key={value}
          variant={variant}
          isActive={value === pageNo}
          onClick={() => setPageNo(value)}
        >
          {value}
        </Count>
      ))}
      <Count
        variant={variant}
        isNextPrevious
        onClick={() => isNextPage && setPageNo((prevState) => prevState + 1)}
        disabled={!isNextPage}
      >
        Next
      </Count>
    </PaginationWrapper>
  );
}

export default Pagination;
